export class I18NErrorMessageProvider {
  constructor(i18n) {
    this.i18n = i18n;
  }

  getMessage(key) {
    return this.i18n.tr(`errorHandler.errorMessages.${key}`);
  }
}
